export default "__VITE_ASSET__ffYho06g__"